<template>
    <div class="template">
        <h1>This is an template page</h1>
    </div>
</template>
<script>
import ObjectParamSupport from "../components/ObjectParamSupport";
import BaseView from "../components/BaseView";
export default {
    mixins:[BaseView,ObjectParamSupport],
    components: {
    },
    props: [],
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
            }
        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(data => {
                        //
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

    },

}
</script>